<template>
  <div class="wrapper">
    <van-cell-group class="content">
        <van-field clearable label="礼品卡卡号" placeholder="请填写卡号" v-model="account" />
      <van-field clearable label="礼品卡密码" placeholder="请填写密码" v-model="password"/>
    </van-cell-group>
    <div class="giftBox">
      <div class="giftInfo" v-if="type==2">
        <span class="unit">￥</span>
        <span class="amount">{{parseFloat(giftInfo.amount)}}</span>
        <span class="name">礼品卡</span>
      </div>
    </div>
    <van-row class="bottom">
      <van-button v-if="type==1" type="danger" round class="btn" @click.native="search">搜索</van-button>
      <van-button v-if="type==2" type="danger" round class="btn" @click.native="exchange">确定兑换</van-button>
    </van-row>
  </div>
</template>

<script>
  import { checkphone, checkempty,handleText } from "./../../assets/js/tool";
  import { mapGetters } from "vuex";
  import weChatShareApi from "../../assets/js/weChatShare";
  export default {
    components: {},
    props: {},
    mixins: [weChatShareApi],
    data() {
      return {
        type:'1',
        account: "",
        password: "",
        giftInfo:{},
      };
    },
    methods: {
      toBottom(){
        window.scrollTo(0,1000)
      },
      search(){
        const that = this;
        const arr = [
          { val: that.account, toast: "请填写卡号" },
          { val: that.password, toast: "请填写密码" },
        ];
        let result = true;
        for (var index = 0; index < arr.length; index++) {
          if (!checkempty(arr[index].val, arr[index].toast)) {
            result = false;
            break;
          }
        }
        if (!result) {
          return;
        }
        this.$commonPost({
          jydm: "flow_60026",
          flow_60026: {
            account: that.account,
            password: that.password,
          }
        }).then(response => {
          if (response.resp_code == "0" && response.resp_result == "0") {
            if(response.list.state=='1'){
              this.type='2'
              this.giftInfo =response.list
            }else{
              this.$toast({
                message: '礼品卡已被兑换',
                duration: 2000
              });
            }
          }else{
            this.$toast({
              message: response.resp_msg,
              duration: 2000
            });
          }
        }).catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
      },
      exchange() {
        const that = this;
        const arr = [
          { val: that.account, toast: "请填写卡号" },
          { val: that.password, toast: "请填写密码" },
        ];
        let result = true;
        for (var index = 0; index < arr.length; index++) {
          if (!checkempty(arr[index].val, arr[index].toast)) {
            result = false;
            break;
          }
        }
        if (!result) {
          return;
        }
        let data = {
          sub_flow:'flow_60028',
          user_nbr:this.userInfo.nbr,
          nbr: that.giftInfo.nbr,
          account: that.account,
          password: that.password,
        };
        let params = { jydm: "flow_10000", flow_10000: data };
        // 加载框子
        const toast = this.$toast({
          type: "loading",
          message: "兑换中...",
          duration: 0,
          mask: true
        });
        this.$commonPost(params)
          .then(response => {
            toast.clear();
            if (response.resp_code == "0" && response.resp_result == "0") {
              this.$toast({
                message: "兑换成功！",
                duration: 2000
              });
              that.giftInfo={};
              that.type='1',
              that.account='';
              that.password='';
            }else{
              this.$toast({
                message: response.resp_msg,
                duration: 2000
              });
            }
          })
          .catch(err => {
            toast.clear();
            this.$toast({
              message: err.message,
              duration: 2000
            });
          });
      },
      initPage(){
        let option = {
          title: '有米@'+this.userInfo.name + "的店铺",
          desc: "欢迎光临我的店铺",
          link: location.origin + "/?supNbr=" + this.userInfo.nbr,
          images: this.userInfo.imgUrl
        };
        this.weChatShare(option);
      }
    },
    created() {
      document.title = "礼品卡兑换";
      this.initPage()
    },
    mounted() {
      window.scrollTo(0,0)
    }
  };
</script>
<style scoped lang='stylus'>
  .content >>> .van-field .van-cell__title {
    width: 1.68rem;
    font-weight: 600;
  }
  .content >>> .van-field__control{
    color:#333333;
  }
</style>
<style scoped lang='less'>
  .wrapper {
    width: 100%;
    background: #f5f5f5;
    min-height: 100vh;
    overflow: hidden;
    padding-bottom: 4rem;
    box-sizing:border-box;
  }
  .content {
    .van-cell {
      padding: 0.24rem;
      font-size: 0.28rem;
      line-height: 0.4rem;
      height: 0.88rem;
      border-bottom: 1px solid #eee;
      box-sizing: border-box;
    }
  }
  .giftBox{
    height: 2.11rem;
    margin: .4rem 0 1.1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .giftInfo{
    width:6.7rem;
    height: 2.11rem;
    background-image: url("../../assets/images/information/giftBg.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .unit{
      font-size: .3rem;
      color: #fff;
      line-height: .42rem;
      font-weight: 500;
      margin-top: -.5rem;
    }
    .amount{
      font-size: 1rem;
      color: #fff;
      line-height: 1.4rem;
      font-weight: bold;
      margin: 0 .1rem;
    }
    .name{
      font-size: .3rem;
      color: #fff;
      line-height: .42rem;
      font-weight: 500;
      margin-top: .4rem;
    }
  }
  .bottom {
    width: 6.9rem;
    margin: 0 auto;
    box-sizing: border-box;
    .btn {
      width: 100%;
      font-size: 0.3rem;
    }
    .van-button--danger {
      color: #fff;
      background: #E52B25;
      border: 1px solid #E52B25;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/information/giftCard.vue